import { useEffect } from 'react';
import { motion } from 'framer-motion';

export default function SplashScreen({ onComplete }) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const timer = setTimeout(() => {
      document.body.style.overflow = '';
      onComplete();
    }, 3200);
    return () => {
      clearTimeout(timer);
      document.body.style.overflow = '';
    };
  }, [onComplete]);

  const name = 'Sarah Watson';

  return (
    <motion.div
      data-testid="splash-screen"
      className="fixed inset-0 z-[10000] bg-[#1B2A4A] flex flex-col items-center justify-center"
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1] }}
    >
      {/* Top gold line */}
      <motion.div
        className="h-px bg-[#C9A96E] mb-10"
        initial={{ width: 0, opacity: 0 }}
        animate={{ width: 100, opacity: 1 }}
        transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      />

      {/* Name - letter by letter */}
      <div className="overflow-hidden">
        <div className="font-serif text-4xl sm:text-5xl md:text-7xl text-[#F7F5F2] tracking-tight flex justify-center">
          {name.split('').map((char, i) => (
            <motion.span
              key={i}
              className="inline-block"
              initial={{ y: 60, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                duration: 0.6,
                delay: 0.5 + i * 0.04,
                ease: [0.22, 1, 0.36, 1],
              }}
              style={{ marginRight: char === ' ' ? '0.25em' : '0.01em' }}
            >
              {char === ' ' ? '\u00A0' : char}
            </motion.span>
          ))}
        </div>
      </div>

      {/* Subtitle */}
      <motion.p
        className="text-[10px] sm:text-xs uppercase tracking-[0.35em] text-[#C9A96E] font-sans font-semibold mt-5"
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 1.6, ease: [0.22, 1, 0.36, 1] }}
      >
        Luminous Coaching
      </motion.p>

      {/* Bottom gold line */}
      <motion.div
        className="h-px bg-[#C9A96E] mt-10"
        initial={{ width: 0, opacity: 0 }}
        animate={{ width: 100, opacity: 1 }}
        transition={{ duration: 1, delay: 2.0, ease: [0.22, 1, 0.36, 1] }}
      />

      {/* Fade-out vignette */}
      <motion.div
        className="absolute inset-0 bg-[#1B2A4A]"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0 }}
        transition={{ delay: 2.8 }}
      />
    </motion.div>
  );
}
